import React from 'react';
import SegmentDetailDrawer from './SegmentDetailDrawer';
import FunnelDetailDrawer from './FunnelDetailDrawer';
import EconomyDetailDrawer from './EconomyDetailDrawer';
import ExpertDetailDrawer from './ExpertDetailDrawer';
import UserDetailDrawer from './UserDetailDrawer';
import SegmentBuilderDrawer from './SegmentBuilderDrawer';
import SessionDetailDrawer from './SessionDetailDrawer';

const DRAWER_TITLE_MAP = {
  user: 'Kullanıcı Detayı',
  cooking: 'Yemek ve Davranış Detayı',
  economy: 'Ekonomi Detayı',
  expert: 'Uzman Detayı',
  segment: 'Segment Detayı',
  funnel: 'Huni Detayı',
  session: 'Oturum Davranışı Detayı',
  'segment-builder': 'Segment Oluşturucu'
};

function PlaceholderContent({ selectedEntity }) {
  return (
    <div className="space-y-3 text-sm text-slate-600 dark:text-slate-300">
      <p className="rounded-lg border border-slate-200 bg-slate-50 p-3 dark:border-slate-800 dark:bg-slate-900">
        Bu panel için detay içerik Faz-B sonrası standart sırayla (`özet başlık -&gt; eğilim -&gt; kırılım -&gt; liste -&gt; alt eylemler`) genişletilecektir.
      </p>
      {selectedEntity ? (
        <pre className="overflow-auto rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs dark:border-slate-800 dark:bg-slate-900">
          {JSON.stringify(selectedEntity, null, 2)}
        </pre>
      ) : null}
    </div>
  );
}

export default function DashboardGlobalDrawerHost({ activeDrawer, selectedEntity, onClose }) {
  const isOpen = Boolean(activeDrawer);
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/40" onClick={onClose}>
      <aside
        className="h-full w-full max-w-[480px] border-l border-slate-200 bg-white shadow-2xl dark:border-slate-800 dark:bg-[#101922] flex flex-col"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="sticky top-0 z-10 flex items-center justify-between gap-2 border-b border-slate-200 bg-white px-5 py-4 dark:border-slate-800 dark:bg-[#101922]">
          <h3 className="text-lg font-black text-slate-900 dark:text-white">{DRAWER_TITLE_MAP[activeDrawer] || 'Detay'}</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-slate-200 px-3 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
          >
            Kapat
          </button>
        </div>

        <div className="flex-1 overflow-y-auto no-scrollbar px-5 py-4">
          {activeDrawer === 'user' ? <UserDetailDrawer entity={selectedEntity} onClose={onClose} /> : null}
          {activeDrawer === 'segment' ? <SegmentDetailDrawer entity={selectedEntity} onClose={onClose} /> : null}
          {activeDrawer === 'funnel' || activeDrawer === 'cooking' ? <FunnelDetailDrawer entity={selectedEntity} onClose={onClose} /> : null}
          {activeDrawer === 'session' ? <SessionDetailDrawer entity={selectedEntity} onClose={onClose} /> : null}
          {activeDrawer === 'economy' ? <EconomyDetailDrawer entity={selectedEntity} onClose={onClose} /> : null}
          {activeDrawer === 'expert' ? <ExpertDetailDrawer entity={selectedEntity} onClose={onClose} /> : null}
          {activeDrawer === 'segment-builder' ? <SegmentBuilderDrawer entity={selectedEntity} onClose={onClose} /> : null}
          {activeDrawer !== 'user' &&
          activeDrawer !== 'segment' &&
          activeDrawer !== 'funnel' &&
          activeDrawer !== 'cooking' &&
          activeDrawer !== 'session' &&
          activeDrawer !== 'economy' &&
          activeDrawer !== 'expert' &&
          activeDrawer !== 'segment-builder' ? (
            <PlaceholderContent selectedEntity={selectedEntity} />
          ) : null}
        </div>
      </aside>
    </div>
  );
}
